/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOAnalyticsDTO } from '../models/ApiResponseDTOAnalyticsDTO';
import type { ApiResponseDTOBeneficiaryChartBaseDTO } from '../models/ApiResponseDTOBeneficiaryChartBaseDTO';
import type { ApiResponseDTOProductAnalyticsChartDTO } from '../models/ApiResponseDTOProductAnalyticsChartDTO';
import type { ApiResponseDTOSalesOverTimeDTO } from '../models/ApiResponseDTOSalesOverTimeDTO';
import type { ApiResponseDTOSendMoneyChartBaseDTO } from '../models/ApiResponseDTOSendMoneyChartBaseDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AnalyticsApiService {

    /**
     * Finds Beneficiary charts
     * Retrieves beneficiary charts
     * @returns ApiResponseDTOBeneficiaryChartBaseDTO OK
     * @throws ApiError
     */
    public static beneficiaryCharts(): CancelablePromise<ApiResponseDTOBeneficiaryChartBaseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/beneficiary',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Finds product analytics charts
     * Retrieves product analytics charts
     * @returns ApiResponseDTOProductAnalyticsChartDTO OK
     * @throws ApiError
     */
    public static getProductAnalyticsCharts(): CancelablePromise<ApiResponseDTOProductAnalyticsChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/product-sales-summary',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Finds sales over time charts
     * Retrieves sales over time charts
     * @returns ApiResponseDTOSalesOverTimeDTO OK
     * @throws ApiError
     */
    public static salesOverTimeCharts(): CancelablePromise<ApiResponseDTOSalesOverTimeDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/sales-over-time',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Finds Send Money charts
     * Retrieves send money charts
     * @returns ApiResponseDTOSendMoneyChartBaseDTO OK
     * @throws ApiError
     */
    public static sendMoneyCharts(): CancelablePromise<ApiResponseDTOSendMoneyChartBaseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/send-money',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Finds total transaction
     * Retrieves total transaction per payment
     * @returns ApiResponseDTOAnalyticsDTO OK
     * @throws ApiError
     */
    public static totalCharged(): CancelablePromise<ApiResponseDTOAnalyticsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/analytics/total-charged',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
